import { Popconfirm as AntPopconfirm } from "antd";
import type { PopconfirmProps as AntPopconfirmProps } from "antd";

export interface PopconfirmProps extends AntPopconfirmProps {
  children: React.ReactNode;
}

export function Popconfirm({ children, ...props }: PopconfirmProps) {
  return <AntPopconfirm {...props}>{children}</AntPopconfirm>;
}
